import { render, staticRenderFns } from "./aside-user-card.vue?vue&type=template&id=717acdd2&"
import script from "./aside-user-card.vue?vue&type=script&lang=js&"
export * from "./aside-user-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports